export function resolveStyles(styles) {
  return classNames => []
    .concat(classNames || [])
    .filter(Boolean)
    .map(name => styles[name] || name)
    .join(' ');
}

export function resolveClassName(styles) {
  const styleResolver = resolveStyles(styles);
  return classNames => ({ className: styleResolver(classNames) });
}
